export enum LANGUAGES {
  en = 'en',
}

